/* eslint-disable react/jsx-props-no-spreading */
import { useEffect, useState } from 'react';

// Utils
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../store/AppContext';
import { isGranted } from '../gate/permissionsGate';

const withPermission = (Component, { scopes }) => {
  function Permission(props) {
    const navigate = useNavigate();
    const [{ user }] = useAppContext();

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
      setMounted(true);
    }, []);

    useEffect(() => {
      if (mounted && (!user || !isGranted(user, scopes))) navigate('/');
    }, [mounted]);

    if (user && isGranted(user, scopes)) return <Component {...props} />;
    return null;
  }

  if (Component.getInitialProps) {
    Permission.getInitialProps = Component.getInitialProps;
  }

  return Permission;
};

export default withPermission;
